exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stickySkyBanners__skyBanner___1VfGM {\n  position: fixed;\n  top: 120px;\n  z-index: 10;\n  width: 300px;\n  display: none; }\n  @media (min-width: 2300px) {\n    .stickySkyBanners__skyBanner___1VfGM {\n      display: block; } }\n\n.stickySkyBanners__skyLeft___1aE4h {\n  left: calc((100vw - 1603px) / 4 - 150px); }\n\n.stickySkyBanners__skyRight___1_KHy {\n  right: calc((100vw - 1603px) / 4 - 150px); }\n", ""]);

// exports
exports.locals = {
	"skyBanner": "stickySkyBanners__skyBanner___1VfGM",
	"skyLeft": "stickySkyBanners__skyLeft___1aE4h",
	"skyRight": "stickySkyBanners__skyRight___1_KHy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/App/StickySkyBanners/stickySkyBanners.scss
// module id = 5127
// module chunks = 6